// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__j4kEJ","breadcrumb-item":"Breadcrumb_breadcrumb-item__dAS40"};